"use client";

import { useMemo } from "react";
import { useSearchParams } from "next/navigation";
import { useTranslations } from "next-intl";

type LoginErrorState = {
  code: string | null;
  message: string | null;
  forceLogin: boolean;
};

export function useLoginError(): LoginErrorState {
  const t = useTranslations("auth");
  const params = useSearchParams();
  const code = params.get("error");

  return useMemo(() => {
    if (!code) {
      return { code: null, message: null, forceLogin: false };
    }

    if (code === "AccessDenied") {
      return {
        code,
        message: t("loginAccessDenied"),
        forceLogin: true,
      };
    }

    if (code === "OAuthAccountNotLinked") {
      return {
        code,
        message: t("loginAccountNotLinked"),
        forceLogin: true,
      };
    }

    return { code, message: t("unknownError"), forceLogin: false };
  }, [code, t]);
}
